export default __webpack_public_path__ + "1e4a26f33077e6977ba77269e326ad55.png";